var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5038 19.9418C19.3751 16.2347 21.8819 15.3112 25.5952 16.4688C31.66 19.1748 37.3634 22.586 42.5798 26.6275C45.6094 28.7997 45.9982 32.4938 42.5798 35.7326C35.7297 40.5323 29.0538 45.1108 24.5228 46.6197C20.7156 47.6993 18.8657 46.4376 18.5038 43.3808C17.8321 35.5814 17.8321 27.7412 18.5038 19.9418Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5032 20.9458C21.3746 17.2349 23.8814 16.3105 27.5948 17.4693C33.6594 20.1734 39.3629 23.5838 44.5798 27.6254C47.6094 29.8129 47.9982 33.5108 44.5798 36.7399C37.7295 41.5575 31.0535 46.0887 26.5223 47.6382C22.7151 48.6929 20.8652 47.3908 20.5032 44.3961C19.8323 36.5929 19.8323 28.749 20.5032 20.9458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.93cd1990df2840a52c2e827c0621581d.svg";
export { ForwardRef as ReactComponent };